import { createSelector } from 'reselect';

import { RequestState, StateDictionary } from '../reducers/utils/state-manager';

export type ApplicantAutomationState = {
  applicantAutomationsById: ApplicantAutomationDictionary;
  applicantAutomationsStateByJobId: StateDictionary;
  applicantAutomationsStateByOrgId: StateDictionary;
};

type ApplicantAutomationDictionary = {
  [applicantTriggeredCommunicationId: number]: ApplicantAutomation;
};

type State = { applicantAutomations: ApplicantAutomationState };

const applicantAutomationsByIdSelector = (state: State) =>
  state.applicantAutomations.applicantAutomationsById;
export const applicantAutomationsForJobIdSelector = createSelector(
  [applicantAutomationsByIdSelector, (_state: State, jobId: number) => jobId],
  (automationsById, jobId) =>
    automationsById ? Object.values(automationsById).filter((c) => c.jobId === jobId) : [],
);
// This will load all org default automations as well as the job-level overrides for that org
export const applicantAutomationsForOrgIdSelector = createSelector(
  [applicantAutomationsByIdSelector, (_state: State, orgId: number) => orgId],
  (automationsById, orgId) =>
    automationsById ? Object.values(automationsById).filter((c) => c.orgId === orgId) : [],
);

const applicantAutomationsStateByJobIdSelector = (state: State) =>
  state.applicantAutomations.applicantAutomationsStateByJobId;
export const applicantAutomationsStateForJobIdSelector = createSelector(
  [applicantAutomationsStateByJobIdSelector, (_state: State, jobId: number) => jobId],
  (automationsStateByJobId, jobId) =>
    automationsStateByJobId ? automationsStateByJobId[jobId] : ({} as RequestState),
);

const applicantAutomationsStateByOrgIdSelector = (state: State) =>
  state.applicantAutomations.applicantAutomationsStateByOrgId;
export const applicantAutomationsStateForOrgIdSelector = createSelector(
  [applicantAutomationsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (automationsStateByOrgId, orgId) =>
    automationsStateByOrgId ? automationsStateByOrgId[orgId] : ({} as RequestState),
);
